
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Book, CreditCard, FileText, Home, TicketIcon, Users } from 'lucide-react';
import SidebarLink from './SidebarLink';

interface AdminLinksProps {
  isOpen: boolean;
}

const AdminLinks: React.FC<AdminLinksProps> = ({ isOpen }) => {
  const location = useLocation();
  
  return (
    <>
      <SidebarLink
        to="/admin/dashboard"
        icon={<Home className="h-5 w-5" />}
        label="Dashboard"
        isActive={location.pathname === '/admin/dashboard'}
        isOpen={isOpen}
      />
      <SidebarLink
        to="/admin/authors"
        icon={<Users className="h-5 w-5" />}
        label="Authors"
        isActive={location.pathname.startsWith('/admin/authors')}
        isOpen={isOpen}
      />
      <SidebarLink
        to="/admin/books"
        icon={<Book className="h-5 w-5" />}
        label="Books"
        isActive={location.pathname.startsWith('/admin/books')}
        isOpen={isOpen}
      />
      <SidebarLink
        to="/admin/royalties"
        icon={<FileText className="h-5 w-5" />}
        label="Royalty Reports"
        isActive={location.pathname.startsWith('/admin/royalties')}
        isOpen={isOpen}
      />
      <SidebarLink
        to="/admin/payments"
        icon={<CreditCard className="h-5 w-5" />}
        label="Payments"
        isActive={location.pathname.startsWith('/admin/payments')}
        isOpen={isOpen}
      />
      <SidebarLink
        to="/admin/support"
        icon={<TicketIcon className="h-5 w-5" />}
        label="Support Tickets"
        isActive={location.pathname.startsWith('/admin/support') || location.pathname.startsWith('/admin/tickets')}
        isOpen={isOpen}
      />
    </>
  );
};

export default AdminLinks;
